<template>
  <div class="relation-tree-box">
    <a-tree
      v-if="developDatasReady"
      show-line
      :expanded-keys="expandedKeys"
      :tree-data="currentDevelopDatas"
      :auto-expand-parent="autoExpandParent"
      :selected-keys="selectedKeys"
      @expand="onExpand"
      @select="onSelect"
    >
      <template
        slot="title"
        slot-scope="{title}"
      >
        <span
          v-if="title.hasChild"
          :title="title.title"
          :class="{hasChild:title.hasChild}"
        >{{ title.title }}</span>
        <span
          v-else
          class="notChild"
          :title="title.title"
          @click="getItemInfo(title)"
        >{{ title.title }}</span>
      </template>
    </a-tree>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
      expandedKeys: [],
      autoExpandParent: true,
      selectedKeys: []
    }
  },
  computed: {
    ...mapState('config/relation', ['developDatasReady']),
    ...mapGetters('config/relation', ['currentDevelopDatas', 'currentData']),
    getDefaultKeys () {
      let arr2 = []
      let obj = {}
      if (this.routeId.length) {
        // arr2 = this.routeId
        obj = this.$route.query
        arr2 = this.getKeys(this.currentDevelopDatas, this.routeId)
      } else {
        const arr = this.getFirstNode(this.currentDevelopDatas)
        arr.forEach(item => {
          arr2.push(item.title.key)
          let newobj = {}
          let key = item.keyname
          newobj[key] = item.id
          Object.assign(obj, newobj)
        })
      }
      return { keys: arr2, obj }
    },
    routeId () {
      const query = this.$route.query
      let arr = []
      if (Object.keys(query).length) {
        arr = [query.roleid * 1, query.groupid * 1, query.userid * 1]
      }
      return arr
    }
  },
  watch: {
    async getDefaultKeys (val) {
      const chain = await this.fetchRelationDatas()
      chain.params(this.getDefaultKeys.obj)
        .onSuccess(raw => {
          this.setTreeItemObj(this.getDefaultKeys.obj)
        })
        .fetch()
    }
  },
  async mounted () {
    // const chain = await this.fetchRelationDatas()
    // chain.params(this.getDefaultKeys.obj).fetch()

    let timeid = setInterval(async () => {
      if (this.developDatasReady) {
        const keys = this.getDefaultKeys.keys
        this.expandedKeys = keys
        this.selectedKeys = [keys[keys.length - 1]]
        clearInterval(timeid)
      }
    }, 2000)
  },
  created () {
  },
  methods: {
    ...mapActions('config/relation', ['fetchRelationDatas']),
    ...mapMutations('config/relation', ['setTreeItemObj']),
    onSelect (selectedKeys, info) {
      this.selectedKeys = selectedKeys
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    async getItemInfo (title) {
      let obj = {}
      let userid = 0
      let groupid = 0
      let roleid = 0
      if (title.key.toString().indexOf('-') > -1) {
        userid = title.key.split('-')[1] * 1
        groupid = title.key.split('-')[0] * 1
        roleid = this.getFirst(this.currentDevelopDatas, groupid)
        obj = {
          userid,
          groupid,
          roleid: roleid[0]
        }
      } else {
        obj = {
          userid: title.key,
          groupid: 0,
          roleid: 0
        }
      }

      const chain = await this.fetchRelationDatas()
      chain.params(obj)
        .onSuccess(raw => {
          this.setTreeItemObj(obj)
        })
        .fetch()
    },
    // familyTree (arr1, id) {
    //   var temp = []
    //   var forFn = function (arr, id) {
    //     for (var i = 0; i < arr.length; i++) {
    //       var item = arr[i]
    //       if (item.id === id) {
    //         temp.push(item)
    //         forFn(arr1, item.pid)
    //         break
    //       } else {
    //         if (item.children) {
    //           forFn(item.children, id)
    //         }
    //       }
    //     }
    //   }
    //   forFn(arr1, id)
    //   return temp
    // },
    getFirst (arr, groupid) {
      let temp = []
      let forFn = function (arr, groupid) {
        for (var i = 0; i < arr.length; i++) {
          if (groupid === arr[i].id) {
            temp.push(arr[i].pid)
          }
          if (arr[i].children && arr[i].children.length) {
            forFn(arr[i].children, groupid)
          }
        }
      }
      forFn(arr, groupid)
      return temp
    },
    getFirstNode (tree) {
      var temp = []
      var forFn = function (arr) {
        if (arr && arr.length > 0) {
          temp.push(arr[0])
          if (arr[0].children) {
            forFn(arr[0].children)
          }
        }
      }
      forFn(tree)
      return temp
    },
    getKeys (treeData, arr) {
      let arr2 = []
      let forFn = function (treeData, arr) {
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < treeData.length; j++) {
            if (arr[i] === treeData[j].id) {
              if (treeData[j].keyname === 'userid' && (arr[1] === treeData[j].pid || (arr[1] === 0 && treeData[j].pid === null))) {
                arr2.push(treeData[j].key)
              }
            }
            if (treeData[j].children && treeData[j].children.length) {
              forFn(treeData[j].children, arr)
            }
          }
        }
      }
      forFn(treeData, arr)
      return arr2
    }
  }
}
</script>

<style>
  .hasChild{
    cursor:not-allowed;
    max-width: 196px;
    text-overflow: ellipsis;
    overflow: hidden;
     display: inline-block;
  }
  .notChild{
    max-width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
  }
  .notChild:hover {
    padding: 0 5px;
    border-radius: 2px;
    margin: 0;
    cursor: pointer;
    text-decoration: none;
    vertical-align: top;
    color: rgba(0, 0, 0, 0.65);
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    height: 24px;
    line-height: 24px;
    background: #dde5eb
  }
</style>
<style lang="scss" scoped>
  .relation-tree-box::v-deep {
    width: 248px;
    float: left;
    padding: 24px;
    background: #f5f6f7;
    border-radius: 4px;
    min-height: 650px;
     .ant-tree li .ant-tree-node-content-wrapper:hover {
    background: none;
    /* // #dde5eb */
  }
    .ant-tree.ant-tree-show-line li span.ant-tree-switcher {
      background: transparent;
    }
  }
</style>
